import React from 'react';
import LegacyForm from './LegacyForm';
import Version2025 from './Version2025';

function RhodeIslandForm(props) {
  const { version } = props;
  const isVersion2025OrLater = !['ri_2021', 'ri_2022', 'ri_2024'].includes(version);

  // ri_2025 onwards will use the new form
  if (isVersion2025OrLater) return <Version2025 {...props} />;

  return <LegacyForm {...props} />;
}

export default RhodeIslandForm;
